import { render, staticRenderFns } from "./Talks.vue?vue&type=template&id=b7c1df70&scoped=true&"
import script from "./Talks.vue?vue&type=script&lang=ts&"
export * from "./Talks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1df70",
  null
  
)

export default component.exports